$(document).on("userLoaded", function() {
    $("#top").html(M.templates.top({
        user: M.CurrentUser,
        current: $(document.body).data("page")
    }));
});